import { render, staticRenderFns } from "./ConsentGroupEdit.vue?vue&type=template&id=6a18c080&scoped=true&"
import script from "./ConsentGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ConsentGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./ConsentGroupEdit.vue?vue&type=style&index=0&id=6a18c080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18c080",
  null
  
)

export default component.exports